// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 895 ? "offer" : chunkId) + "." + {"347":"1a4427b3","866":"3deecdfb","895":"6e85c068"}[chunkId] + ".css";
};